import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';
import postEndBreak from 'Api/monitoring/postEndBreak';
import { postEndBreakText } from 'Const/monitoring/domain';

import postEndBreakPayload from './model/request/postEndBreakPayload';

const usePostEndBreak = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const queryClient = useQueryClient();
  const { onResetModal } = useModal();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = postEndBreakPayload(formData);

      const result = await postEndBreak(payload);

      return result;
    },
    onMutate: () => onShowLoader({ variant: 'loader-primary' }),
    onSuccess: async (response) => {
      onResetModal();
      const durationMinutes = response?.breakStopped?.durationMinutes ?? '0';
      const durationSeconds = response?.breakStopped?.durationSeconds ?? '0';

      const successMessage = postEndBreakText.getSuccessDescriptionText({
        time: `${durationMinutes} menit ${durationSeconds} detik`,
        isBreak: response?.breakStopped?.breakType?.code !== 'BANTU_REKAN',
      });

      onOpenToast({ status: 'success', description: successMessage, duration: 5, alwaysShow: false });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['monitoring-operator-status'] }),
        queryClient.invalidateQueries({ queryKey: ['break'] }),
        queryClient.invalidateQueries({ queryKey: ['daily-log'] }),
      ]);
    },
    onError: (error) => {
      console.log(error);
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : postEndBreakText.defaultErrorMessageText;
      onOpenToast({ status: 'error', description: errorMessage, duration: 5, alwaysShow: false });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostEndBreak;
